export interface IFormProps {
  useForm?: any
  nextStep?: any
  previousStep?: any
  currentStep?: number | string
  registerField?: any
  handleSubmit?: any
  errors?: any
  isValid?: boolean
  onSubmit?: any
  watch?: any
  setValue?: any
  resetField?: any
  getValues?: any
  Controller?: any
  control?: any
  setError?: any
  clearErrors?: any
  paymentOptionSelected?: any
  setPaymentOptionSelected?: any
  setFormState?: any
  investorType?: string
  setInvestorType?: any
  calcProgressState?: any
  subscriptionAgreement?: any
  setSubscriptionAgreement?: any
  currentStage?: any
  setCurrentStage?: any
  retirementAccntType?: any
  setRetirementAccntType?: any
  handleFormData?: any
  validateFields?: any
  reset?: any
  unregister?: any
}

export interface OnboardIndividualData {
  email: string
  _id: string
  investingProfile: {
    option: string
  }
  citizenshipInfo: {
    country: string
  }
  addressInfo: {
    state: string
    zip: string
    address1: string
    address2: string
    city: string
  }
  basicInfo: {
    firstName: string
    lastName: string
  }
  personalInfo: {
    phoneNumber: string
    birthday: string
  }
  financialInfo: {
    ssn: string
  }
}

export interface CreateTradeData {
  offeringId: string
  accountId: string
  transactionType: string
  transactionUnits: string
}

export interface CreateExternalAccountData {
  accountId: string
  ExtAccountfullname: string
  Extnickname: string
  ExtBankname: string
  ExtRoutingnumber: string
  ExtAccountnumber: string
}

export interface FundMoveACHData {
  accountId: string
  offeringId: string
  tradeId: string
  NickName: string
  amount: string
  checkNumber: string
}

export enum InvestingPersonEnum {
  FOR_MYSELF = 'FOR_MYSELF',
  JOINTLY = 'JOINTLY',
  IN_BEHALF_OF_AN_ENTITY = 'IN_BEHALF_OF_AN_ENTITY',
  RETIREMENT = 'RETIREMENT',
}

export enum RetirementAccountEnum {
  RETIREMENT_ACCOUNT = 'RETIREMENT_ACCOUNT',
  TRUST_ACCOUNT = 'TRUST_ACCOUNT',
}
